import { API } from "@API/API";
import { urlFunctions } from "@API/functions/createUrl";
import { CourseStatus } from "@lib/Enums/CourseStatus";
import { AddCourseFormSubmitDataType } from "@lib/Types/AddCourseFormSubmitType";
import { mapFormToAPI } from "@lib/mapperFunctions/mapFormToAPI";
import { mapFormToAPIDrafted } from "@lib/mapperFunctions/mapFormToAPIDrafted";

type editCourseResponseType =
  | {
      success: true;
      data: any;
    }
  | {
      success: false;
      data: string;
    };

export const editCourse = async function (
  data: AddCourseFormSubmitDataType,
  id: string,
  status: CourseStatus
): Promise<editCourseResponseType> {
  let formattedData;
  if (status === CourseStatus.PUBLISH) {
    formattedData = mapFormToAPI(data);
  } else {
    formattedData = mapFormToAPIDrafted(data);
  }
  const url = urlFunctions.editCourse(id);
  const res = await API.sendPutRequest(url, formattedData, true);
  if (res.success) {
    return {
      success: true,
      data: null,
    };
  } else {
    return {
      success: false,
      data: "Could not edit course try again",
    };
  }
};
